import EmblaCarousel from 'embla-carousel';
import addPrevNextBtnsClickHandlers from './EmblaCarouselArrowButtons';
import '../assets/css/embla.css';

const initCarousel = () => {
  const OPTIONS = {};

  const emblaNode = document.querySelector('.embla');
  const viewportNode = emblaNode.querySelector('.embla__viewport');
  const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
  const nextBtnNode = emblaNode.querySelector('.embla__button--next');

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

  const removeDotBtnsAndClickHandlers = addPrevNextBtnsClickHandlers(
    emblaApi,
    prevBtnNode,
    nextBtnNode
  );

  emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
};

export default initCarousel;
